<template lang="pug">
.__element-container(
  @click="$emit('click', $event)"
  :class="{ '__element-container_cursor': cursor }"
)
  slot
</template>

<script>
export default {
  props: {
    cursor: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.__element-container {
  display: block;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #d2d2d2;
  border-radius: .2em;
  box-shadow: inset 2px 2px 8px rgba(0,0,0,.1);
  outline: 0;
  cursor: pointer;
  line-height: 1.5em;
  user-select: none;
  text-align: left;
  position: relative;
  z-index: 1;
  transition: all 300ms ease-in-out;

  &:hover {
    border-color: #a5aeb5;
    box-shadow: inset 2px 2px 8px rgba(0, 0, 0, .15);
  }

  &_cursor {
    cursor: default;
  }
}
</style>



// WEBPACK FOOTER //
// Container.vue?66e01edc